import { assertEnv } from "@homeinstead/shared";

/**
 * Returns the Google Maps API key from the environment.
 */
export function getGoogleMapsApiKey(): string | undefined {
  return assertEnv(
    "NEXT_PUBLIC_GOOGLE_MAPS_API_KEY",
    process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  );
}
